import Vue from 'vue';
import App from './app.vue';
import { router } from './router/index';
import 'famfamfam-flags/dist/sprite/famfamfam-flags.css';
import './theme.less';
import Ajax from './lib/ajax';
import Util from './lib/util';
import SignalRAspNetCoreHelper from './lib/SignalRAspNetCoreHelper';
import VueSweetalert2 from 'vue-sweetalert2';
import VueHtmlToPaper from 'vue-html-to-paper';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faUserSecret } from '@fortawesome/free-solid-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { faJs, faVuejs, fab } from '@fortawesome/free-brands-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faHatWizard } from '@fortawesome/free-solid-svg-icons';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import i18n from './lib/i18n';
import Maska from 'maska';
import moment from 'moment';
import VueUpper from 'vue-upper';
import Tracker from '@openreplay/tracker';
import {
  ValidationProvider,
  ValidationObserver,
  extend,
  localize,
  configure,
} from 'vee-validate';
import VeeValidate from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { required } from 'vee-validate/dist/rules';
const options = {
  name: '_blank',
  specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
  ],
};

library.add(fas, faJs, faVuejs, fab);
moment.locale(i18n.locale);

Vue.use(Maska);
Vue.use(VueUpper);
Vue.use(VueSweetalert2);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
Vue.use(VueHtmlToPaper, options);
Vue.use(VueToast, { position: 'bottom-right' });
Vue.component('font-awesome-icon', FontAwesomeIcon);

extend('maxInfantOld', {
  params: ['minDate', 'maxDate'],
  validate: (value, { minDate, maxDate }: any) => {
    var compareDate = moment(value, 'DD-MM-yyyy');
    var startDate = moment(maxDate, 'DD-MM-yyyy');
    var endDate = moment(minDate, 'DD-MM-yyyy');
    if (compareDate.isBetween(startDate, endDate, null, '()')) {
      return true;
    }
    return false;
  },
});

extend('maxChildOld', {
  params: ['minDate', 'maxDate'],
  validate: (value, { minDate, maxDate }: any) => {
    var compareDate = moment(value, 'DD-MM-yyyy');
    var startDate = moment(maxDate, 'DD-MM-yyyy');
    var endDate = moment(minDate, 'DD-MM-yyyy');
    if (compareDate.isBetween(startDate, endDate, null, '()')) {
      return true;
    }
    return false;
  },
});

extend('maxAdultOld', {
  params: ['minDate', 'maxDate'],
  validate: (value, { minDate, maxDate }: any) => {
    var compareDate = moment(value, 'DD-MM-yyyy');
    var startDate = moment(maxDate, 'DD-MM-yyyy');
    var endDate = moment(minDate, 'DD-MM-yyyy');
    if (compareDate.isBetween(startDate, endDate, null, '()')) {
      return true;
    }
    return false;
  },
});

extend('pasaportInvalid', {
  params: ['minDate'],
  validate: (value, { minDate }: any) => {
    var compareDate = moment(value, 'DD-MM-yyyy');
    var endDate = moment(minDate, 'DD-MM-yyyy');
    if (compareDate.isAfter(endDate)) {
      return true;
    }
    return false;
  },
});

Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

Vue.filter('formatOnlyDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD-MM-yyyy');
  }
});
import store from './store/index';
import vuetify from '@/plugins/vuetify';
Vue.config.productionTip = false;

import '@/assets/vendor/fontawesome-free/css/all.min.css'; /* injected */

import '@/assets/vendor/jquery/jquery.min.js'; /* injected */
import '@/assets/vendor/bootstrap/js/bootstrap.bundle.min.js'; /* injected */
import '@/assets/vendor/jquery-easing/jquery.easing.min.js'; /* injected */
import '@/assets/js/sb-admin-2.min.js'; /* injected */
import '@/assets/css/sb-admin-2.css'; /* injected */

import { appRouters, otherRouters } from './router/router';
import { install } from 'vuex';
if (!abp.utils.getCookieValue('Abp.Localization.CultureName')) {
  let language = navigator.language;
  abp.utils.setCookieValue(
    'Abp.Localization.CultureName',
    language,
    new Date(new Date().getTime() + 5 * 365 * 86400000),
    abp.appPath
  );
}
Vue.config.productionTip = false;

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD-MM-YYYY HH:mm');
  }
});

Vue.filter('formatOnlyDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD-MM-YYYY');
  }
});
Vue.filter('formatInDay', function (value) {
  if (value) {
    return moment(String(value)).format('LL dddd');
  }
});

//Ajax.get('/AbpUserConfiguration/GetAll').then(data=>{

//Util.abp=Util.extend(true,Util.abp,data.data.result);
var token = Util.abp.auth.getToken();
Util.abp = Util.extend(true, Util.abp, token);

new Vue({
  render: (h) => h(App),
  router: router,
  store: store,
  data: {
    currentPageName: '',
  },

  async mounted() {
    this.currentPageName = this.$route.name as string;
    await this.$store.dispatch({
      type: 'session/init',
    });
    // if(!!this.$store.state.session.user&&this.$store.state.session.application.features['SignalR']){
    // if (this.$store.state.session.application.features['SignalR.AspNetCore']) {
    // SignalRAspNetCoreHelper.initSignalR();
    // }
    // }

    this.$store.commit('app/initCachepage');
    this.$store.commit('app/updateMenulist');
    configure({
      defaultMessage: (field, values): any => {
        values._field_ = i18n.t(`fields.${field}`);
        return i18n.t(`validations.messages.${values._rule_}`, values);
      },
    });
  },
  created() {
    let tagsList: Array<any> = [];
    appRouters.map((item) => {
      if (item.children.length <= 1) {
        tagsList.push(item.children[0]);
      } else {
        tagsList.push(...item.children);
      }
    });
    // if (!localStorage.lang) {
    //   localStorage.setItem('lang', 'ru');
    //   i18n.locale = 'ru';
    // }
    const hash = window.location.hash;

    // Hash kısmından parametreleri çıkarmak için '?' işaretinden sonraki kısmı al
    const hashQueryString = hash.split('?')[1];
    
    // URL'nin query string kısmını al
    const urlQueryString = window.location.search.slice(1);
    
    // URLSearchParams ile parametreleri ayrıştır
    const hashParams = new URLSearchParams(hashQueryString);
    const urlParams = new URLSearchParams(urlQueryString);
    
    // Öncelikli olarak hashParams içindeki locale parametresini kontrol et
    let localeParam = hashParams.get('locale');
    if (!localeParam) {
      // Eğer hashParams içinde yoksa, urlParams içindeki locale parametresini kontrol et
      localeParam = urlParams.get('locale');
    }
    
    // locale parametresini kontrol et ve dil ayarlarını yap
    if (localeParam === 'ru') {
      localStorage.setItem('lang', 'ru');
      i18n.locale = 'ru';
    } else if (localeParam === 'en') {
      localStorage.setItem('lang', 'en');
      i18n.locale = 'en';
    } else if (localeParam === 'tr') {
      localStorage.setItem('lang', 'tr');
      i18n.locale = 'tr';
    } else {
      // Eğer locale parametresi yoksa veya tanınmayan bir değer ise varsayılan olarak 'ru' dilini kullan
      localStorage.setItem('lang', 'ru');
      i18n.locale = 'ru';
    }
    
   
    
    this.$store.commit('app/setTagsList', tagsList);
  },
  vuetify,
  i18n,
}).$mount('#app');



const tracker = new Tracker({
  projectKey: "CGIJ1gPRSf46J2a2A4eF",
  ingestPoint: "https://stats.charterscanners.com/ingest",
  __DISABLE_SECURE_MODE:true,
  captureExceptions:true,
  defaultInputMode: 0,
  obscureTextEmails: false,
  
});

tracker.start();
//})
